import Vue from 'vue/dist/vue.esm.js'
Vue.component 'report-rows-agreement-row',
  template: JST['report_rows/agreement_row']()
  props: ['initialRow']

  data: ->
    row: @initialRow
    errors: {}
    destroying: false
    authenticity_token: $('meta[name="csrf-token"]').attr('content')

  computed:
    rowId: ->
      "row-#{@row.id}"

    hasErrors: ->
      @row.exceeds_total_value || @row.exceeds_applicable_value

  watch:
    row:
      handler: -> @updateRow()
      deep: true

  methods:
    updateRow: ->
      @errors = {}
      $.ajax
        dataType: 'JSON',
        url: "/admin/report_agreement_rows/#{@row.id}"
        method: 'PUT'
        data: { @row, authenticity_token: @authenticity_token }
        success: =>
          @flashRow('#bfdf9f')
        error: (data) =>
          @errors = data.responseJSON
          Helper.flashRow($(@$el), '#d10404')
      @.$emit('update-row', @row)

    flashRow: (color_code) ->
      $(@$el).animate({
        backgroundColor: color_code
      }, 1000 ).animate({
        backgroundColor: '#fff'
      }, 1000 )

    destroyAgreementRow: ->
      return if @destroying # don't run request twice if button is quickly pressed more than once
      if confirm I18n.t("javascript.row_delete_confirmation")
        @destroying = true
        $.ajax
          dataType: 'JSON',
          url: "/admin/report_agreement_rows/#{@row.id}",
          data: {authenticity_token: @authenticity_token},
          method: 'DELETE'
        @.$emit('destroy-row', @row)
